import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function SettingsSvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 8.29076C13.4659 8.88415 14.5 10.3213 14.5 12C14.5 13.6787 13.4659 15.1159 12 15.7092L12 24C12 24.8284 11.3284 25.5 10.5 25.5C9.67157 25.5 9 24.8284 9 24V15.7092C7.53408 15.1159 6.5 13.6787 6.5 12C6.5 10.3213 7.53408 8.88415 9 8.29076V6C9 5.17157 9.67157 4.5 10.5 4.5C11.3284 4.5 12 5.17157 12 6L12 8.29076ZM9.5 12C9.5 11.4477 9.94771 11 10.5 11C11.0523 11 11.5 11.4477 11.5 12C11.5 12.5523 11.0523 13 10.5 13C9.94771 13 9.5 12.5523 9.5 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.5 4.5C21.3284 4.5 22 5.17157 22 6V14.2908C23.4659 14.8841 24.5 16.3213 24.5 18C24.5 19.6787 23.4659 21.1159 22 21.7092V24C22 24.8284 21.3284 25.5 20.5 25.5C19.6716 25.5 19 24.8284 19 24V21.7092C17.5341 21.1159 16.5 19.6787 16.5 18C16.5 16.3213 17.5341 14.8841 19 14.2908V6C19 5.17157 19.6716 4.5 20.5 4.5ZM21.5 18C21.5 18.5523 21.0523 19 20.5 19C19.9477 19 19.5 18.5523 19.5 18C19.5 17.4477 19.9477 17 20.5 17C21.0523 17 21.5 17.4477 21.5 18Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default SettingsSvg;
